import { Building2, Briefcase, Landmark, DollarSign, Receipt, BookOpen, ChartNoAxesCombined } from 'lucide-react';
import { canSeePortalAsesor, portalAsesorMode } from '@/lib/canSeePortalAsesor';

export const clientes = [
  { nameKey: 'nav.portal_asesor',
    nameKeyFor: ctx => portalAsesorMode(ctx) === 'group' ? 'nav.mis_empresas' : 'nav.portal_asesor',
    pageName: 'PortalAsesor', pathFor: ctx => portalAsesorMode(ctx) === 'group' ? '/mis-empresas' : '/portal-asesor',
    matchPaths: ['/portal-asesor', '/mis-empresas'], icon: Building2,
    showIf: ctx => canSeePortalAsesor(ctx), zone: 'context' },
];
export const finanzas = [
  { nameKey: 'navigation.finance', icon: Landmark, zone: 'work', subItems: [
    { nameKey: 'nav.accounting', pageName: 'Accounting', icon: BookOpen, permission: 'accounting.view', descriptionKey: 'navigation.descriptions.accounting' },
    { nameKey: 'navigation.banking', pageName: 'Bancos', icon: DollarSign, permission: 'accounting.view', descriptionKey: 'navigation.descriptions.banking', shortcuts: [
      { nameKey: 'nav.reconciliation', params: { tab: 'conciliacion' }, permission: 'banking.view' },
    ] },
    { nameKey: 'nav.taxes', pageName: 'Impuestos', icon: Receipt, permission: 'fiscal.view', descriptionKey: 'navigation.descriptions.taxes' },
    { nameKey: 'navigation.portfolio', pageName: 'Cartera', icon: Briefcase, permission: 'accounting.view', descriptionKey: 'navigation.descriptions.portfolio' },
    { nameKey: 'navigation.financial_reports', pageName: 'Accounting', id: 'accounting-reports', path: '/accounting/reports',
      icon: ChartNoAxesCombined, permission: 'accounting.view', descriptionKey: 'navigation.descriptions.financial_reports' },
  ] },
];
export const nav = [...clientes, ...finanzas];
